export default {
  groups: [],
  count: 0,
  lastFilter: {},
};



// WEBPACK FOOTER //
// ./src/store/modules/group/state.js